import React from "react";

const LoadingPage = () => {
  return (
    <div style={styles.loadingScreen}>
      <div style={styles.loadingContainer}>
        <div style={styles.spinner}></div>
        <p>Завантаження...</p>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  loadingScreen: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  loadingContainer: {
    backgroundColor: "white",
    padding: "30px",
    borderRadius: "8px",
    textAlign: "center",
    boxShadow: "0 0 20px rgba(0, 0, 0, 0.3)",
  },
  spinner: {
    border: "5px solid #f3f3f3",
    borderTop: "5px solid #3498db",
    borderRadius: "50%",
    width: "50px",
    height: "50px",
    animation: "spin 1s linear infinite",
    margin: "0 auto 20px",
  },
};

export default LoadingPage;